var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c("div", { staticClass: "columns" }, [
          _c("label", { staticClass: "column label" }, [
            _vm._v("Select from Below"),
          ]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchTextField,
                expression: "searchTextField",
              },
            ],
            staticClass: "column input is-pulled-right is-hidden",
            attrs: { type: "text", placeholder: "Search" },
            domProps: { value: _vm.searchTextField },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.filterQuotes()
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.searchTextField = $event.target.value
              },
            },
          }),
        ]),
        _c(
          "bulma-table",
          {
            staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
            attrs: {
              columns: _vm.columns,
              "page-index": _vm.filter.pageIndex,
              "page-size": _vm.filter.pageSize,
              "total-rows": _vm.totalRows,
              "is-loading": _vm.isTableLoading,
              "sort-column": _vm.filter.sortColumn,
              "sort-order": _vm.filter.sortOrder,
              "show-pagination": false,
            },
            on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
          },
          [
            _vm._l(_vm.entitySummaries, function (entity, index) {
              return _c(
                "tr",
                {
                  key: entity.quoteNo,
                  class: { "is-selected": _vm.selectedRow === index },
                  on: {
                    click: function ($event) {
                      return _vm.highlightSelected(index, $event)
                    },
                  },
                },
                [
                  _c("td", [_vm._v(" " + _vm._s(entity.quoteNoRef) + " ")]),
                  _c("td", [_vm._v(" " + _vm._s(entity.regoNo) + " ")]),
                  _c("td", [_vm._v(" " + _vm._s(entity.make) + " ")]),
                  _c("td", [_vm._v(" " + _vm._s(entity.model) + " ")]),
                  _c("td", [_vm._v(" " + _vm._s(entity.claimNo) + " ")]),
                  _c("td", [_vm._v(" " + _vm._s(entity.jobStageText) + " ")]),
                ]
              )
            }),
            _c("template", { slot: "empty" }, [
              _c("section", { staticClass: "section" }, [
                _c(
                  "div",
                  { staticClass: "content has-text-grey has-text-centered" },
                  [
                    _c("span", { attrs: { icon: "icon is-large" } }, [
                      _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
                    ]),
                    _c("p", [_vm._v("Nothing")]),
                  ]
                ),
              ]),
            ]),
          ],
          2
        ),
      ],
      1
    ),
    _vm.invalidQuoteId
      ? _c("span", { staticClass: "has-text-danger" }, [
          _vm._m(0),
          _vm._v(" Please select a quote before continuing. "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-danger" }, [
      _c("i", { staticClass: "mdi mdi-alert-octagram mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }